import React from "react";
import { AppBar, Toolbar, Box, Tooltip, Typography } from "@mui/material";
import TitleBarActions from "./title-bar-actions";

export interface TitleBarProps {
  title?: string | JSX.Element;
  titleLogo?: string;
  barColor?: string;
  titleColor?: string;
  noTooltip?: boolean;
  actions?: {
    name: string;
    icon: string;
    tooltip: string;
    actionFunction: (props?: unknown) => void;
    disabled?: boolean;
  }[];
  noAction?: boolean;
  actionComponent?: JSX.Element;
  openFeedbackFrom?: string;
  onMouseDown?: (e: React.MouseEvent) => void;
  onClose?: (props?: unknown) => void;
}

const TitleBar: React.FC<TitleBarProps> = (props) => {
  const {
    title,
    barColor,
    titleColor,
    noAction = false,
    actionComponent,
    noTooltip = true,
    onMouseDown,
    onClose,
  } = props;

  const closeWindow = () => {
    if (onClose) onClose();
  };

  return (
    <AppBar
      position="relative"
      elevation={0}
      onMouseDown={onMouseDown}
      sx={{
        backgroundColor: barColor ?? "transparent",
        boxShadow: "none",
        borderRadius: "8px 8px 0 0",
      }}
      className={`title-bar title-bar${!barColor && title ? " bb" : ""}`}
    >
      <Toolbar
        variant="dense"
        disableGutters
        sx={{
          minHeight: title === undefined ? "30px" : "40px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{ display: "flex", alignItems: "center" }}
          className="title-text-container"
          onMouseDown={onMouseDown}
        >
          {actionComponent && (
            <Box sx={{ flexGrow: 0 }} className="left-title-action">
              {actionComponent}
            </Box>
          )}

          <Box className="title-bar__title-item">
            {noTooltip ? (
              <Typography variant="body1" sx={{ color: titleColor ?? "#FFF" }}>
                {title}
              </Typography>
            ) : (
              <Tooltip
                title={title ?? ""}
                placement="bottom"
                className="eui-title-bar-tooltip"
              >
                <Typography
                  variant="body1"
                  sx={{ color: titleColor ?? "#FFF" }}
                >
                  {title}
                </Typography>
              </Tooltip>
            )}
          </Box>
        </Box>

        {!noAction && (
          <TitleBarActions onWindowClose={closeWindow} {...props} />
        )}
      </Toolbar>
    </AppBar>
  );
};

export default TitleBar;
